import * as server from '../entries/pages/(admin)/admin/home/_page.server.ts.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/home/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/(admin)/admin/home/+page.server.ts";
export const imports = ["_app/immutable/nodes/5.CBTHjqAK.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/BCt2Yrch.js","_app/immutable/chunks/DjbxhWhX.js","_app/immutable/chunks/CrkJ0M0_.js","_app/immutable/chunks/C1FmrZbK.js","_app/immutable/chunks/DcKRL2at.js","_app/immutable/chunks/CFMktExA.js"];
export const stylesheets = ["_app/immutable/assets/Editor.DleZyqak.css"];
export const fonts = [];
